import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StatsigProvider } from "statsig-react";
import { SsoGate } from "@labeling-tools/ui-components";
import { auth, signIn } from "@/utils/auth";
import { StoreListPage } from "./pages/StoreListPage";
import { StoreDetailPage } from "./pages/StoreDetailPage";
import { CalendarPage } from "./pages/CalendarPage";
import { DeploymentsPage } from "./pages/DeploymentsPage";

function App() {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60 * 5,
            retry: 1,
          },
        },
      }),
  );

  const statsigClientKey = import.meta.env.VITE_STATSIG_CLIENT_KEY;

  const routes = (
    <Routes>
      <Route path="/" element={<StoreListPage />} />
      <Route path="/store/:storeId" element={<StoreDetailPage />} />
      <Route path="/hours" element={<CalendarPage />} />
      <Route path="/deployments" element={<DeploymentsPage />} />
    </Routes>
  );

  return (
    <SsoGate
      auth={auth}
      signIn={signIn}
      ssoLoginUrl={import.meta.env.VITE_SSO_LOGIN_URL}
      devMode={import.meta.env.DEV}
      appName="Store Management"
      ssoEnabled={true}
    >
      {(user) => (
        <QueryClientProvider client={queryClient}>
          {statsigClientKey ? (
            <StatsigProvider
              sdkKey={statsigClientKey}
              user={{
                userID: user.uid,
                email: user.email ?? undefined,
              }}
            >
              {routes}
            </StatsigProvider>
          ) : (
            routes
          )}
        </QueryClientProvider>
      )}
    </SsoGate>
  );
}

export default App;
